import { API_URL } from '../../../app-config/constants';
import { get, post, put } from '../request';
export type CompanyOnboardingDto = {
    id?: string | undefined;
    userId?: string;
    companyId?: string;
    role?: string;
    companySize?: number;
    origin?: string;
    createdAt?: string;
    interests?: string[];
    requestedDemo?: boolean;
    hris?: string;
    featuresHidden?: boolean;
};

// not using ladda's idFrom because that currently doesn't work with COMMAND or UPDATE
const addMissingFields = (response: CompanyOnboardingDto) => {
    if (response) {
        return {
            ...response,
            id: response.userId,
        };
    } else {
        return {
            id: '',
        };
    }
};

createOnboardingSettings.operation = 'NO_OPERATION';
export function createOnboardingSettings(request: CompanyOnboardingDto): Promise<CompanyOnboardingDto> {
    const postData = { ...request };
    return post(`${API_URL}/onboarding-survey/`, { postData: postData });
}

updateOnboardingSettings.operation = 'COMMAND';
export function updateOnboardingSettings(request: CompanyOnboardingDto) {
    const postData = { ...request };
    return put<CompanyOnboardingDto>(`${API_URL}/onboarding-survey/update/`, { postData: postData }).then(
        addMissingFields
    );
}

getOnboardingSettings.operation = 'NO_OPERATION';
export function getOnboardingSettings(): Promise<CompanyOnboardingDto | null> {
    return get<CompanyOnboardingDto>(`${API_URL}/onboarding-survey/`).then(addMissingFields);
}

getCompanySizeFilled.operation = 'NO_OPERATION';
export function getCompanySizeFilled(): Promise<boolean> {
    return get(`${API_URL}/onboarding-survey/company-size/`);
}

showAllFeatures.operation = 'COMMAND';
export function showAllFeatures() {
    return put<CompanyOnboardingDto>(`${API_URL}/onboarding-survey/show-all-features/`).then(addMissingFields);
}
